import { Component, AfterViewInit, HostListener, ElementRef, Renderer2 } from '@angular/core'

@Component({
  selector: 'flo-adhesion-footer',
  templateUrl: './adhesion-footer.component.html',
  styleUrls: ['./adhesion-footer.component.scss']
})
export class AdhesionFooterComponent implements AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  private footerEl: HTMLElement | null = null

  ngAfterViewInit() {
    this.footerEl = document.getElementById('flo-footer')
    this.adjustPosition()
  }

  @HostListener('window:scroll')
  @HostListener('window:resize')
  onScrollOrResize() {
    this.adjustPosition()
  }

  private adjustPosition() {
    if (!this.footerEl) return

    const stickyAd: HTMLElement = this.el.nativeElement.querySelector('.adhesion-footer')
    if (!stickyAd) return
    const stickyHeight = stickyAd.offsetHeight
    const footerRect = this.footerEl.getBoundingClientRect()
    const viewportHeight = window.innerHeight

    if (footerRect.top < viewportHeight) {
      const overlap = viewportHeight - footerRect.top
      this.renderer.setStyle(stickyAd, 'transform', `translateY(${Math.min(overlap, stickyHeight)}px)`)
    } else {
      this.renderer.setStyle(stickyAd, 'transform', `translateY(0)`)
    }
  }
}
